export * from './UIGameActionButtonKnightMove.tsx';
